var map = {
	"./Accomplishment.png": 1378,
	"./Calendar-VGL-icon.png": 821,
	"./CollapseFilled.png": 678,
	"./GlobalGivingCausesThumb.png": 1098,
	"./Mistake.png": 1379,
	"./TablePlaceholder.png": 588,
	"./appointments.png": 1380,
	"./calendar.png": 1381,
	"./class-duration-icon.png": 1382,
	"./clients.png": 1383,
	"./dashboard.png": 72,
	"./delete.png": 1384,
	"./event-calendar.png": 1108,
	"./excel-icon.png": 1385,
	"./personal.png": 1386,
	"./reports.png": 1387,
	"./sales.png": 1388,
	"./vector-cover-image.png": 1389,
	"./vectorglobal.png": 1390,
	"./vectorgloballogo.png": 1391,
	"./vg-logo.png": 1100,
	"./vgl-blank-image.png": 1392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1107;